import React from 'react';
import classes from './AnnouncementBar.module.css'

const AnnouncementBar = () => {
    return (
        <div className={classes.AnnouncementBar}>
        </div>
    )
}

export default AnnouncementBar;